import { render, staticRenderFns } from "./VersionNav.vue?vue&type=template&id=27fed72d&scoped=true"
import script from "./VersionNav.vue?vue&type=script&lang=js"
export * from "./VersionNav.vue?vue&type=script&lang=js"
import style0 from "./VersionNav.vue?vue&type=style&index=0&id=27fed72d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fed72d",
  null
  
)

export default component.exports